module.exports = __webpack_public_path__ + "static/media/flecha.784c8b31.svg";